import {
  startOfWeek,
  subWeeks,
  addDays,
  isWithinInterval,
  endOfDay,
} from 'date-fns';
import {Colors} from 'src/styles';

export const cancellationReasonMap = {
  client: {
    title: 'Client Initiated',
    color: Colors.LIME_500,
  },
  staff: {
    title: 'Staff Initiated',
    color: Colors.TEAL_500,
  },
  error: {
    title: 'Added in Error',
    color: Colors.TORCH_RED_LIGHT,
  },
  absent: {
    title: 'Student Absent',
    color: Colors.VIOLET_500,
  },
  noShow: {
    title: 'No Show',
    color: Colors.RUBY_500,
  },
  other: {
    title: 'Other',
    color: Colors.ORANGE,
  },
};

const allReasons = Object.keys(cancellationReasonMap);

export const calculateCancellationRate = (appointments: any[]) => {
  const now = new Date();

  const weeks: {
    week: string;
    start: Date;
    end: Date;
    total: number;
    counts: Record<string, number>;
    percentages: Record<string, number>;
  }[] = [];

  for (let i = 11; i >= 0; i--) {
    const start = startOfWeek(subWeeks(now, i), {weekStartsOn: 0});
    const end = addDays(start, 7);

    const counts: Record<string, number> = {};
    allReasons.forEach(key => {
      counts[key] = 0;
    });

    weeks.push({
      week: start.toISOString().split('T')[0],
      start,
      end,
      total: 0,
      counts,
      percentages: {},
    });
  }

  for (const appt of appointments) {
    const {cancellationReason, date} = appt;
    if (!cancellationReason || !allReasons.includes(cancellationReason)) {
      continue;
    }

    const apptDate = endOfDay(new Date(date));

    for (const week of weeks) {
      if (isWithinInterval(apptDate, {start: week.start, end: week.end})) {
        week.total += 1;
        week.counts[cancellationReason] += 1;
        break;
      }
    }
  }

  for (const week of weeks) {
    const {total, counts} = week;
    const percentages: Record<string, number> = {};
    allReasons.forEach(key => {
      const count = counts[key] || 0;
      percentages[key] = total > 0 ? Math.round((count / total) * 100) : 0;
    });
    week.percentages = percentages;
  }

  return weeks.map(({week, total, counts, percentages}) => ({
    week,
    total,
    counts,
    percentages,
  }));
};
